import { render, staticRenderFns } from "./ModalBackup2FA.vue?vue&type=template&id=7a40cd9a"
import script from "./ModalBackup2FA.vue?vue&type=script&lang=js"
export * from "./ModalBackup2FA.vue?vue&type=script&lang=js"
import style0 from "./ModalBackup2FA.vue?vue&type=style&index=0&id=7a40cd9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports